
export class NumberScanModalResult {
  constructor(
    public scannedNumber: string,
    public data: any = null,
  ) {
  }
}
